import { FirebaseAnalytics } from "@capacitor-firebase/analytics";
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';
import { Build } from "@stencil/core";
import { Capacitor } from "@capacitor/core";

export class AnalyticsService {
  public static instance: AnalyticsService = new AnalyticsService();
  private active = Capacitor.isNativePlatform() && !Build.isTesting;

  private constructor() {

  }

  setUserId(userId: string) {
    if (this.active && userId) {
      FirebaseAnalytics.setUserId({
        userId
      });
    }
  }

  setAppId(appId: string) {
    if (this.active && appId) {
      FirebaseAnalytics.setUserProperty({
        key: 'appId',
        value: appId
      });
    }
  }

  logEvent(event: string, params: Record<string, any> = {}) {
    if (this.active) {
      FirebaseAnalytics.logEvent({
        name: event,
        params
      });
    }
  }

  setScreen(screen: string) {
    if (this.active) {
      FirebaseAnalytics.setCurrentScreen({
        screenName: screen,
        screenClassOverride: screen
      });
      FirebaseCrashlytics.setCustomKey({
        key: 'page',
        value: screen,
        type: 'string'
      });
    }
  }
}